import React, { Component } from 'react';
import './App.css';
import UserScoreQuiz from './UserScoreQuiz';

class App extends Component {
  render() {
    return (
      <div className="App">
        
        <UserScoreQuiz />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js